import { useEffect, useState } from "react"

export function buildAuthHeaders(includeJson = false) {
  const token = localStorage.getItem("odontoflow_token") || ""
  const clinicId = localStorage.getItem("odontoflow_clinic_id") || ""

  const headers = {}

  if (includeJson) {
    headers["Content-Type"] = "application/json"
  }

  if (token) {
    headers["Authorization"] = `Bearer ${token}`
  }

  if (clinicId && clinicId !== "ALL") {
    headers["x-clinic-id"] = clinicId
  }

  return headers
}

export default function useBackendOpportunities({ clinicId, date }) {
  const [backendOpportunityItems, setBackendOpportunityItems] = useState([])
  const [loadingBackendOpportunityItems, setLoadingBackendOpportunityItems] = useState(false)

  useEffect(() => {
    setBackendOpportunityItems([])
    setLoadingBackendOpportunityItems(false)
  }, [clinicId, date])

  return {
    backendOpportunityItems,
    loadingBackendOpportunityItems
  }
}
